const pageNameKey = "blueprintDescriptionPopover";

export const blueprintDescriptionPopoverEn = {
  [pageNameKey]: { descriptionAuthor: `Description by` },
};

export const blueprintDescriptionPopoverPtBr = {
  [pageNameKey]: { descriptionAuthor: `descrição de` },
};

export const blueprintDescriptionPopoverDe = {
  [pageNameKey]: { descriptionAuthor: `Beschreibung von` },
};

export const blueprintDescriptionPopoverZhHans = {
  [pageNameKey]: { descriptionAuthor: `描述者` },
};

export const blueprintDescriptionPopoverIt = {
  [pageNameKey]: { descriptionAuthor: `Descrizione di` },
};

export const blueprintDescriptionPopoverEs = {
  [pageNameKey]: { descriptionAuthor: `Description by` },
};

export const blueprintDescriptionPopoverNl = {
  [pageNameKey]: {
    descriptionAuthor: "Beschrijving van",
  },
};

export const blueprintDescriptionPopoverTr = {
  [pageNameKey]: {
    descriptionAuthor: "Açıklama:",
  },
};
